var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"icons8-twitter","d":"M24,4.3a9.006,9.006,0,0,1-2.8.8,5.324,5.324,0,0,0,2.2-2.7,9.078,9.078,0,0,1-3.1,1.2A5.233,5.233,0,0,0,16.6,2a4.908,4.908,0,0,0-4.9,4.9A3.75,3.75,0,0,0,11.8,8,13.676,13.676,0,0,1,1.7,2.9,4.3,4.3,0,0,0,1,5.4,5.021,5.021,0,0,0,3.2,9.5,7.089,7.089,0,0,1,1,8.9V9a4.85,4.85,0,0,0,3.9,4.8,5.067,5.067,0,0,1-1.3.2,2.769,2.769,0,0,1-.9-.1,4.741,4.741,0,0,0,4.6,3.4,10,10,0,0,1-6.1,2.1A4.869,4.869,0,0,1,0,19.3a14,14,0,0,0,7.5,2.2,13.874,13.874,0,0,0,14-14V6.9A10.3,10.3,0,0,0,24,4.3","transform":"translate(0 -2)","fill":"#81e6d9"}));
}

Twitter.defaultProps = {"width":"24","height":"19.5","viewBox":"0 0 24 19.5"};

module.exports = Twitter;

Twitter.default = Twitter;
